import { WorklistActionsComponent } from '../components/worklist-actions/worklist-actions.component';
import { WorklistExecuteComponent } from '../components/worklist-execute/worklist-execute.component';

export interface ITablelistAction {
  action: (self?: WorklistActionsComponent) => void;
  displayCondition?: (self: WorklistActionsComponent, action?: ITablelistAction) => boolean;
  displayConditionDefinition?: string;
  enableCondition?: (self: WorklistActionsComponent, action?: ITablelistAction) => boolean;
  enableConditionDefinition?: string;
  key: string;
  label: string;
  payload?: string;
}

export interface ITablelistExecute {
  action: (self?: WorklistExecuteComponent) => void;
  displayCondition?: (self: WorklistExecuteComponent, action?: ITablelistExecute) => boolean;
  displayConditionDefinition?: string;
  enableCondition?: (self: WorklistExecuteComponent, action?: ITablelistExecute) => boolean;
  enableConditionDefinition?: string;
  key: string;
  label: string;
  payload?: string;
}

